<div class="m-2">
    <mat-card>
        <mat-card-content>
            <div style="display: flex; flex-direction: row-reverse; align-items: center; gap: 8px;">
                <div style="display: flex; gap: 8px;">
                    <button (click)="openScheduleCallBottomSheet()" [disabled]="isLoading" color="primary"
                            mat-raised-button>
                        Schedule a call
                    </button>
                    <button (click)="getCalls()" [disabled]="isLoading" color="primary" mat-raised-button>
                        <mat-icon *ngIf="isLoading">refresh</mat-icon>
                        Refresh
                    </button>
                </div>
                <mat-slide-toggle
                        (change)="onDateRangeToggle($event)"
                        [checked]="showPastDueCall"
                        [disabled]="isLoading"
                        color="primary">
                    Show past due calls
                </mat-slide-toggle>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mt-4">
        <mat-card-content>
            <!-- State display component -->
            <app-state-display
                *ngIf="showStateDisplay"
                [type]="stateType"
                loadingMessage="Loading calls..."
                emptyMessage="No calls scheduled"
                [errorMessage]="errorMessage || 'Failed to load calls'"
                emptyIcon="phone"
                errorIcon="error_outline">
            </app-state-display>

            <!-- Calls table -->
            <table mat-table [dataSource]="dataSourceApplicationCalls" *ngIf="showTable">
                <ng-container matColumnDef="applicant">
                    <th mat-header-cell *matHeaderCellDef>Applicant</th>
                    <td mat-cell *matCellDef="let call">{{ Applicant.toDisplayText(call.applicant) }}</td>
                </ng-container>
                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell *matCellDef="let call">{{ call.subject }}</td>
                </ng-container>
                <ng-container matColumnDef="purpose">
                    <th mat-header-cell *matHeaderCellDef>Purpose</th>
                    <td mat-cell *matCellDef="let call">{{ ApplicationCallPurpose.toDisplayText(call.purpose) }}</td>
                </ng-container>
                <ng-container matColumnDef="dateTime">
                    <th mat-header-cell *matHeaderCellDef>Date time</th>
                    <td mat-cell *matCellDef="let call">{{ DateUtil.formatDate(call.dateTime) }}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let call">{{ ApplicationCallStatus.toDisplayText(call.status) }}</td>
                </ng-container>
                <ng-container matColumnDef="createdBy">
                    <th mat-header-cell *matHeaderCellDef>Created by</th>
                    <td mat-cell *matCellDef="let call">{{ call.createdByEmployee.name }}</td>
                </ng-container>
                <ng-container matColumnDef="ownedBy">
                    <th mat-header-cell *matHeaderCellDef>Owned by</th>
                    <td mat-cell *matCellDef="let call">{{ call.ownedByEmployee.name }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let call;index as i;">
                        <button mat-icon-button (click)="completeCall(call); $event.stopPropagation()" matTooltip="Complete">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                        <button mat-icon-button (click)="cancelCall(call); $event.stopPropagation()" matTooltip="Cancel">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsApplicationCalls"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsApplicationCalls" (click)="editCall(row)" class="clickable-row"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
